module.exports = __webpack_public_path__ + "media/images/quick_search/format/img_mobile_2-49a29ce94046bc6992774dd4614697c8.png";